export default function RenderingGrid({ imageUrls, renderings }) {
  return (
    <div className="renderings-grid" data-testid="renderings-grid">
      {renderings.map((rendering) => (
        <article key={rendering.rendering_id} data-testid={`investor-rendering-${rendering.rendering_id}`}>
          {imageUrls[rendering.rendering_id] ? <img src={imageUrls[rendering.rendering_id]} alt={rendering.alt_text} data-testid={`rendering-image-${rendering.rendering_id}`} /> : <div className="rendering-image-fallback" data-testid={`rendering-image-unavailable-${rendering.rendering_id}`}>Image unavailable</div>}
          <div>
            <span>Concept rendering</span>
            <h3>{rendering.title}</h3>
            <p>{rendering.caption}</p>
          </div>
        </article>
      ))}
    </div>
  );
}